
import axios from 'axios'
import authHeader from './auth-header'

class SearchService {
  ApolloSearch ( query, signal ) {
    return axios.post(
      process.env.VUE_APP_API_URL + 'busca/full/text/' + encodeURIComponent(query),
      {},
      { headers: authHeader(), signal }
    )
  }

  getCollaboratorDetails ( idColaborador ) {
    return axios.get(process.env.VUE_APP_API_URL + `colaborador/search-details/${idColaborador}`, { headers: authHeader() })
  }
}

export default new SearchService()
